export const ADD_FACET_DIALOG_EXPANDED_PUBLICATION_YEAR_GROUP =
  "browse-media/ADD_FACET_DIALOG_EXPANDED_PUBLICATION_YEAR_GROUP";
export const ADD_FACET_DIALOG_SELECTED_PUBLICATION_YEAR =
  "browse-media/ADD_FACET_DIALOG_SELECTED_PUBLICATION_YEAR";
export const ADD_FACET_DIALOG_SELECTED_PUBLICATION_YEAR_GROUP =
  "browse-media/ADD_FACET_DIALOG_SELECTED_PUBLICATION_YEAR_GROUP";
export const ADD_FACET_DIALOG_SELECTED_TERM =
  "browse-media/ADD_FACET_DIALOG_SELECTED_TERM";
export const ADD_MODULES_DRAWER_DESELECT_ALL =
  "browse-media/ADD_MODULES_DRAWER_DESELECT_ALL";
export const ADD_MODULES_DRAWER_FILTER_QUERY_CHANGED =
  "browse-media/ADD_MODULES_DRAWER_FILTER_QUERY_CHANGED";
export const ADD_MODULES_DRAWER_MODULES_LOADED =
  "browse-media/ADD_MODULES_DRAWER_MODULES_LOADED";
export const ADD_MODULES_DRAWER_MODULE_SELECTED =
  "browse-media/ADD_MODULES_DRAWER_MODULE_SELECTED";
export const ADD_SELECTED_MODULES = "browse-media/ADD_SELECTED_MODULES";
export const APPLY_ADD_MODULES_DRAWER_FILTER_QUERY =
  "browse-media/APPLY_ADD_MODULES_DRAWER_FILTER_QUERY";
export const APPLY_FACET_DIALOG_FACET = "browse-media/APPLY_FACET_DIALOG_FACET";
export const HIDE_ADD_MODULES_DRAWER = "browse-media/HIDE_ADD_MODULES_DRAWER";
export const HIDE_FACET_DIALOG = "browse-media/HIDE_FACET_DIALOG";
export const HIDE_REMOVE_MODULES_DRAWER =
  "browse-media/HIDE_REMOVE_MODULES_DRAWER";
export const LIMIT_CHANGE = "browse-media/LIMIT_CHANGE";
export const MEDIA_ITEMS_SYNCED = "browse-media/MEDIA_ITEMS_SYNCED";
export const MEDIA_SELECTED = "browse-media/MEDIA_SELECTED";
export const OFFSET_CHANGE = "browse-media/OFFSET_CHANGE";
export const QUERY_CHANGE = "browse-media/QUERY_CHANGE";
export const REMOVE_FACET = "browse-media/REMOVE_FACET";
export const REMOVE_FACET_DIALOG_EXPANDED_PUBLICATION_YEAR_GROUP =
  "browse-media/REMOVE_FACET_DIALOG_EXPANDED_PUBLICATION_YEAR_GROUP";
export const REMOVE_FACET_DIALOG_SELECTED_PUBLICATION_YEAR =
  "browse-media/REMOVE_FACET_DIALOG_SELECTED_PUBLICATION_YEAR";
export const REMOVE_FACET_DIALOG_SELECTED_PUBLICATION_YEAR_GROUP =
  "browse-media/REMOVE_FACET_DIALOG_SELECTED_PUBLICATION_YEAR_GROUP";
export const REMOVE_FACET_DIALOG_SELECTED_TERM =
  "browse-media/REMOVE_FACET_DIALOG_SELECTED_TERM";
export const REMOVE_MODULES_DRAWER_DESELECT_ALL =
  "browse-media/REMOVE_MODULES_DRAWER_DESELECT_ALL";
export const REMOVE_MODULES_DRAWER_MODULES_LOADED =
  "browse-media/REMOVE_MODULES_DRAWER_MODULES_LOADED";
export const REMOVE_MODULES_DRAWER_MODULE_SELECTED =
  "browse-media/REMOVE_MODULES_DRAWER_MODULE_SELECTED";
export const REMOVE_QUERY = "browse-media/REMOVE_QUERY";
export const REMOVE_SELECTED_MODULES = "browse-media/REMOVE_SELECTED_MODULES";
export const SEARCH = "browse-media/SEARCH";
export const SEARCH_RESULTS_LOADED = "browse-media/SEARCH_RESULTS_LOADED";
export const SELECT_ALL = "browse-media/SELECT_ALL";
export const SET_FACET_DIALOG_SELECTED_TERMS =
  "browse-media/SET_FACET_DIALOG_SELECTED_TERMS";
export const SHOW_ADD_MODULES_DRAWER = "browse-media/SHOW_ADD_MODULES_DRAWER";
export const SHOW_FACET_DIALOG = "browse-media/SHOW_FACET_DIALOG";
export const SHOW_MORE_ADD_MODULES_DRAWER_MODULES =
  "browse-media/SHOW_MORE_ADD_MODULES_DRAWER_MODULES";
export const SHOW_REMOVE_MODULES_CONFIRMATION_DIALOG =
  "browse-media/SHOW_REMOVE_MODULES_CONFIRMATION_DIALOG";
export const SHOW_REMOVE_MODULES_DRAWER =
  "browse-media/SHOW_REMOVE_MODULES_DRAWER";
export const SHOW_REMOVE_MODULES_DRAWER_FOR_SELECTIONS =
  "browse-media/SHOW_REMOVE_MODULES_DRAWER_FOR_SELECTIONS";

